// extracted by mini-css-extract-plugin
export default {"headerContainer":"UhIPeQQkuWImV8DgLvQ6"};